import { IModuleConfig, MenuKind } from '@simac/ui';
import { ApidocsRoute } from '../apidocs/config.routes';
import { BackendConfigRoute } from '../backendconfig/backendconfig.routes';
import { ConfigRoute } from '../config/config.routes';
import { LoggingRoute } from '../logging/config.routes';

export const ItsmModuleConfig: IModuleConfig = {
  name: 'itsm',
  routing: {
    menuKind: MenuKind.Main,
    route: 'itsm',
    children: [
      {
        title: 'MENU.ITSM-CONFIG',
        route: ConfigRoute,
        permission: 'Module.Itsm.Config.View',
        icon: 'far fa-folder-gear',
      },
      {
        title: 'MENU.ITSM-BACKEND-CONFIG',
        route: BackendConfigRoute,
        validForUser: (session) =>
          session.permissions?.find((o) => o === 'Module.Itsm.BackendConfig.View') !== undefined ||
          session.permissions?.find((o) => o === 'Module.Itsm.ApimSubscription.View') !== undefined,
        icon: 'far fa-link',
      },
      {
        title: 'MENU.ITSM-LOGGING',
        route: LoggingRoute,
        permission: 'Module.Itsm.AppEventLog.View',
        icon: 'far fa-timeline',
      },
      {
        title: 'MENU.ITSM-APIDOCS',
        route: ApidocsRoute,
        permission: 'Module.Itsm.ApiDocs.View',
        icon: 'far fa-square-code',
      },
    ],
  },
  breadCrumb: {
    logging: [
      { key: 'itsm', label: '', hide: true },
      { key: 'page', label: 'MENU.ITSM-LOGGING' },
      { key: 'flowType', label: '' },
      { key: 'operation', label: '' },
    ],
  },
  injects: [
    {
      name: 'projectmanagement',
      components: [
        {
          name: 'configmanagement',
          icon: 'far fa-folder-gear',
          translateLabel: 'MENU.ITSM-CONFIG',
          permission: 'Module.Itsm.ConfigManagement.View',
          pages: [
            {
              isDefault: true,
              route: 'config-management',
              loadComponent: () => import('../projectmanagement/config/pages/config-management.component').then((m) => m.ConfigManagementComponent),
            },
            {
              isDefault: false,
              route: 'config-management/:itsmApiVersion/:flowType/:backendType',
              loadComponent: () => import('../projectmanagement/config/pages/config-management-details.component').then((m) => m.ConfigManagementDetailsComponent),
            },
          ],
        },
        {
          name: 'loggingmanagement',
          icon: 'far fa-timeline',
          translateLabel: 'MENU.ITSM-LOGGING',
          permission: 'Module.Itsm.AppEventLogManagement.View',
          pages: [
            {
              isDefault: true,
              route: 'logging-management',
              loadComponent: () => import('../projectmanagement/logging/pages/logging-management.component').then((m) => m.LoggingManagementComponent),
            },
          ],
        },
      ],
    },
  ],
};
